import React, { useState } from 'react'
import { intl } from 'lang/intl'
import classnames from 'classnames'
import { TtIcon } from '@23/react'
import Chyron, { ChyronSize } from './chyron'

import './webinar-info-chyron.scss'

interface WebinarInfoChyronProps {
  title: string
  date: Date
  locale: string
  thumbnail: string
}

const WebinarInfoChyron = ({
  title,
  date,
  locale,
  thumbnail,
}: WebinarInfoChyronProps) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  return (
    <Chyron
      size={ChyronSize.Medium}
      kickerPosition="top"
      kicker={intl.formatMessage({ defaultMessage: 'Webinar Info' })}
    >
      <div className="webinar-info-chyron">
        {thumbnail && (
          <img
            className={classnames('thumbnail', {
              'thumbnail-loaded': imageLoaded,
            })}
            src={thumbnail}
            alt="Thumbnail of the webinar"
            onLoad={() => setImageLoaded(true)}
          />
        )}
        <div className="info">
          <p className="title">{title}</p>
          <p className="date">
            <TtIcon name="calendar-clock" library="23" />
            {`${new Intl.DateTimeFormat(locale, {
              dateStyle: 'full',
              timeStyle: 'short',
            }).format(date)}`}
          </p>
        </div>
      </div>
    </Chyron>
  )
}

export default WebinarInfoChyron
